import { apodizationFilter } from './apodizationFilter';
export const id = 'apodization';
export const name = 'Apodization';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: false,
};
export function apply(datum1D, options) {
    if (!isApplicable(datum1D)) {
        throw new Error('apodization not applicable on this data');
    }
    const { lineBroadening = 1, gaussBroadening = 0, lineBroadeningCenter = 0, } = options;
    // if no options is set, we add the default value to filter
    if (Object.keys(options).length === 0) {
        const filter = datum1D.filters?.find((filter) => filter.name === id);
        if (filter) {
            filter.value = { lineBroadening, gaussBroadening, lineBroadeningCenter };
        }
    }
    const newData = apodizationFilter(datum1D, {
        lineBroadening,
        gaussBroadening,
        lineBroadeningCenter,
    });
    datum1D.data = {
        ...datum1D.data,
        re: newData.re,
        im: newData.im,
    };
}
export function isApplicable(datum1D) {
    if (datum1D.info.isComplex && datum1D.info.isFid)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: newValue,
    };
}
//# sourceMappingURL=apodization.js.map